import { render, staticRenderFns } from "./quirion-chat.vue?vue&type=template&id=c832c170&"
import script from "./quirion-chat.vue?vue&type=script&setup=true&lang=js&"
export * from "./quirion-chat.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports